export default {
    cart: {
      account: 'ชำระเงิน'
    },
    tips: {
      cart_success: "เพิ่มไปยังตะกร้าสำเร็จแล้ว",
      add_success: "เพิ่มสำเร็จแล้ว",
      empty: "ไม่พบอะไรเลย~",
      order_success: "ขอแสดงความยินดีด้วย ท่านทำการสั่งซื้อสำเร็จแล้วค่ะ",
      chose: "กรุณาเลือก",
      un_pay_on_line: "ยังไม่สนับสนุนการชำระเงินออนไลน์",
      area_not_empty: "กรุณากรอกที่อยู่ของท่านค่ะ",
      name_not_empty: "กรุณากรอกชื่อของท่านค่ะ",
      address_not_empty: "กรุณากรอกที่อยู่ของท่านค่ะ",
      phone_not_empty: "เบอร์โทรศัพท์ไม่ถูกต้องค่ะ"
    },
    detail: {
      carriage: 'ค่าจัดส่ง',
      surplus: 'ที่เหลือ',
      goods_detail: 'รายละเอียดสินค้า',
      cart: 'รถเข็นสินค้า',
      add_cart: 'เพิ่มไปยังรถเข็น',
      buy_now: 'ซื้อเลย',
      CloseOrder:'คำสั่งซื้อที่สมบูรณ์',
      Subtotal:'รวมค่าสินค้า',
      mange:'การจัดการ',
      Total:'ยอดรวมทั้งหมด',
      jian:'รายการ',
      Delivery_method:'วิธีการจัดส่ง',
      paypaly_method:'วิธีการชำระเงิน',
      paypaly1:'เก็บเงินปลายทาง',
      paypaly2:'การชำระเงินออนไลน์',
      paypalyOut:'ในการพัฒนา， กรุณาอดใจรอหน่อย'
    },
    order: {
      freeFreight:'ค่าขนส่งฟรี',
      allTotal:'ยอดเงินชำระ',
      query:'สอบถามโลจิสติกส',
      goods_info: 'ข้อมูลสินค้า',
      pay_way: 'วิธีการชำระเงิน',
      offline: 'เก็บเงินปลายทาง',
      online: 'ชำระเงินออนไลน์',
      pick_info: 'ข้อมูลการรับของ',
      name_name: 'ชื่อ',
      name: 'ชื่อผู้รับ',
      phone_name: 'เบอร์โทรศัพท์',
      phone: 'โทรศัพท์มือถือของผู้รับ',
      area: 'ภูมิภาค จังหวัด เขต/อำเภอ ฯลฯ',
      region: 'ภูมิภาค',
      address_name: 'รายละเอียดที่อยู่',
      address: 'บ้านเลขที่ หมู่ที่ ซอย ถนน ตำบล/แขวง ฯลฯ',
      offer_order: 'ยืนยันการสั่งซื้อ',
    },
    data: {
      Recipient_name:'ชื่อผู้รับ',
      Recipient_nameTips:'กรุณากรอกชื่อจริง - นามสกุลจริงของผู้รับ เพื่อให้แน่ใจว่าได้รับของอย่างราบรื่น',
      Select_M:'เลือกร้านค้า',
      email:"อีเมล์ผู้รับ",
      Select_M_number:'ชื่อร้านค้า',
      Selected_store_name:'เลือกชื่อร้านค้า',
      Shop_address:'ที่อยู่ร้านค้า',
      address:'กรุณาเลือกที่อยู่',
      Choose_payment_method:'วิธีการชำระเงินที่เลือก',
      default_address:'ประเทศไทย',
    },
    indexdata:{
      index:'หน้าแรก',
      list:'รายการ',
      placeholder:'กรอกคำสำคัญในการค้นหา',
      Return:'กลับ'
    },
    Product_details_page: {
      guarantee:'รับประกัน',
      guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
      numbertext:'จำนวน',
      Select_product_specification:'ยืนยันการสั่งซื้อ',
      Package_selection: 'คำเเนะนำสินค้า',
      Buy_now: 'ยืนยันการสั่งซื้อ'
    },
    newOrder:{
      Order_information:'ข้อมูลใบสั่งซื้อ',
      Selection_of_delivery_and_payment_methods:'เลือกวิธีการจัดส่งและวิธีการชำระเงิน',
      Delivery_place:'ที่อยู่ของผู้รับ',
      tw:'ประเทศไทย',
      Delivery_method:'วิธีการจัดส่ง',
      Sub_total:'ยอดร่วมของส่วนหนึ่ง',
      Freight_charges:'สินค้า',
      Total:'ยอดรวมทั้งหมด',
      Go_to_checkout:'ไปชำระเงิน',
    },
    order3: {
      Total:'รวมทั้งหมด  ฿',
      Delivery_information:'ยอดรวมทั้งหมด',
      Freight_charges:'ข้อมูลการจัดส่ง',
      change:'เปลี่ยน',
      Search_shop:'เลือกร้านค้า',
      Order_notes:'ฝากข้อความไว้ของใบสั่งซื้อ',
      Payment_information:'ข้อมูลการชำระเงิน',
      Payment_method_selected:'วิธีการชำระเงินที่เลือก',
      Submit_order: 'ส่งคำสั่งซื้อ',
      xxdz:'กรุณากรอกรายละเอียดที่อยู่ของท่านค่ะ',
      Select_address: 'เลือกที่อยู่',
      Tell_the_seller:'มีอะไรที่อยากจะบอกกับผู้ขายไหมคะ?',
      freight:"ค่าจัดส่ง:",
      Spesifikasi_jualan_pendek:'สเปคนี้ขายหมดแล้ว',
    },
    index:{
      placeholder:'กรุณากรอกคำสำคัญในการค้นหา',
      index:'หน้าแรก',
      list: 'รายการ',
      language:'เลือกภาษา'
    },
    Guarantee:{
      num:'ปริมาณ',
      Pickup_method:'สนับสนุน 7-11, Family Super Merchant Pickup',
      Guarantee:'การประกันคุณภาพ',
      Freight:'จัดส่งฟรี',
      Commodity_pic:'รูปภาพสินค้า',
      Options:'ตัวเลือก',
      selected:'สินค้าที่เลือก',
      Total_price:'ราคาสั่งซื้อทั้งหมด',
      Finally_cope:'ในที่สุดก็รับมือ',
      message:'ฝากข้อความ',
      region:'ภูมิภาค',
      region_s:'จังหวัด',
      country:'ภูมิภาค',
      village:'เขต/อำเภ'
    },
    Pay:{
      language:'เก็บเงินปลายทาง',
      money:'฿',
      to:'ข้ามไปที่หน้าแรกภายในไม่กี่วินาที',
      postcode:'รหัสไปรษณีย์',
      setMeal:'ราคาแพ็คเกจรวม',
      success:'สั่งซื้อเรียบร้อยแล้ว!',
      time:'ผู้ขายจะยืนยันการสั่งซื้อของคุณโดยอัตโนมัติภายใน 10 นาที!',
      realMoney:'จำนวนเงินที่จ่ายจริง',
      orderNumber:'เลขที่ใบสั่งซื้อ',
      waitFor:'พ่อค้าไม่ได้จัดส่งโปรดอดทนรอ'
    },
    comment:{
      comment:'แสดงความคิดเห็น',
      Praise:'สรรเสริญ',
      Average:'เฉลี่ย',
      Badreview:'รีวิวไม่ดี',
      submitcomments:'ส่งความคิดเห็น',
      PleaseEnteraComment:'กรุณาใส่ความคิดเห็น'
    },
    Toast:{
      inputName:'กรุณาใส่ชื่อ',
      inputPhone:'กรุณาใส่หมายเลขโทรศัพท์',
      inputZip:'กรุณาใส่รหัสไปรษณีย์',
      inputAddress:'กรุณากรอกที่อยู่โดยละเอียด',
      inputAlertAddress:'ไม่ได้ส่งที่อยู่โปรดเปลี่ยนเป็นที่อยู่อื่น',
    },
    contactUs:{
      callMe:'หากต้องการเรียนรู้เพิ่มเติม <br> กรุณาติดต่อ Messenger ของหน้า Facebook ของเรา!',
      afterShop:`ช้อปปิ้งแล้ว,กรุณาติดต่อเรา:<br>Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'ยืนยัน',
      shortSale:'คุณสมบัติที่ขายออก',
    },
    ensure:{
      introduce:'คำเเนะนำสินค้า',
      Specifications:'ข้อมูลจำเพาะ',
      ensure:'การรับประกันสินค้า',
      di:'สินค้า',
      commodity:' '
    },
    wuliu:{
      orderSearch:'สอบถามการสั่งซื้อ',
      provide:'ข้อมูลนี้มีเจ้าหน้าที่ด้านโลจิสติกส์:',
      OrderOrLogistics:'หมายเลขคำสั่งซื้อ / หมายเลขใบสั่งขนส่ง (กรอกข้อมูลเพื่อสอบถาม)',
      orderPlaceho:'กรอกข้อมูลที่เกี่ยวข้องเเละสอบถาม',
      query:'สอบถามหมายเลขการสั่งซื้อ',
      Tips:'เคล็ดลับ',
      Tipsinfo:'หากคุณมีคำถามใด ๆ หลังจากได้รับสินค้าโปรดติดต่อฝ่ายบริการลูกค้าออนไลน์หรือส่งอีเมลไปที่ service325@hotmail.com ในเวลาเดียวกันโปรดแจ้งชื่อ / ข้อมูลติดต่อ / หมายเลขคำสั่งซื้อ เราจะรีบจัดการให้ทันเวลาขอให้คุณช้อปปิ้งอย่างมีความสุข!',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/tg.js